/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

//aタグ スムーススクロール
$(function(){
  function anker(href,speed) {
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;

      var $hd = $('.l-header');

      position -= $hd.innerHeight();

      $("html, body").animate({scrollTop:position}, speed, "swing");
      return false;
  };

  var urlHash = location.hash;
  if(urlHash){
    anker(urlHash,0);
  }

  $('a[href^="#"]').click(function(){
    var href= $(this).attr("href");
    anker(href,500);
    return false;
  });

});

//外部ページからアンカーリンクをクリックした時の処理
$(window).on("load", function () {
  if (window.location.hash) {
    setTimeout(function () {
      var target = $(window.location.hash);
      if (target.length) {
        var headerOffset = $("header").outerHeight();
        var elementPosition = target.offset().top;
        $("html, body").animate({
          scrollTop: elementPosition - headerOffset
        }, 600);
      }
    }, 500);
  }
});

$(function(){
  const $btn = $('.js-nextOpen');

  if($btn[0]) {
    $btn.on('click', function(event) {
      $(this).toggleClass('is-on').next().stop().slideToggle(600);
    });
  }
});

$(function(){
  const $hd = $('.l-header.-home');

  if($hd[0]) {
    const $main = $('.l-main');

    $(window).on('scroll', function(event) {
      run();
    });

    run();

    function run() {
      if($(window).scrollTop() + $hd.innerHeight() > $main.offset().top) {
        $hd.removeClass('is-homeKv');
      } else {
        $hd.addClass('is-homeKv');
      }
    }
  }
});

$(function(){
  const hasTapEvent = ( 'ontouchstart' in window );
	const nav_parent = $( '.js-nav-parent' );
	if ( nav_parent.length > 0 ) {
		if ( ! hasTapEvent ) {
			nav_parent.hover(
				function() {
					$( 'body' ).addClass( 'is-nav-show' );
					$( this ).addClass( 'is-show' );
					$( this ).find( '.p-hd__submenu' ).stop().slideDown(100);
				},
				function() {
					$( 'body' ).removeClass( 'is-nav-show' );
					$( this ).removeClass( 'is-show' );
					$( this ).find( '.p-hd__submenu' ).stop().slideUp(50);
				}
			);
		}
	}
});

$(function(){
  const $menu = $('.p-hd__menu button');

  if($menu[0]) {
    const $nav = $('.p-hd__nav');
    const $hd = $('.l-header');

    $menu.on('click', function(event) {
      $menu.toggleClass('is-on');
      $nav.toggleClass('is-show');
      $hd.toggleClass('is-menu');
    });
  }

  window.addEventListener('wheel',function(e){
    if($menu.hasClass('is-on')) {
      e.preventDefault();
    }
  },{passive:false})

  window.addEventListener('touchmove',function(e){
    if($menu.hasClass('is-on')) {
      e.preventDefault();
    }
  },{passive:false})

  document.addEventListener('keydown', e => {
    if($menu.hasClass('is-on')) {
      let direction = null;
      if (e.code === 'ArrowDown') {
        e.preventDefault();
      } else if (e.code === 'ArrowUp') {
        e.preventDefault();
      } else if (e.code === 'PageUp') {
        e.preventDefault();
      } else if (e.code === 'PageDown') {
        e.preventDefault();
      } else if (e.code === 'Space') {
        e.preventDefault();
      } else {
        return;
      }
    }
  },{passive:false});
});

$(function(){
  const $ys = $('.history-side__ys a');

  if($ys[0]) {
    const $item = $('.history-con__item');
    const $h = $('.l-header');

    $(window).on('scroll', function(event) {
      run();
    });

    run();

    function run() {
      let a = $(window).scrollTop() + $h.innerHeight() + 100;
      let now = 0;

      $item.each(function(index, el) {
        const $t = $(this);
        let b = $t.offset().top;

        if(a > b) {
          now = index;
        }
      });


      $ys.removeClass('is-cr').eq(now).addClass('is-cr');
    }
  }
});

$(function(){
  const $root = $('.aboutOfficer-con__item');

  if($root[0]) {
    $root.each(function(index, el) {
      const $item = $(this);
      const $info1 = $item.find('.aboutOfficer-con__itemInfo1');
      const $info2 = $item.find('.aboutOfficer-con__itemInfo2');
      const $close = $item.find('.aboutOfficer-con__itemClose');

      $info1.on('click', function(event) {
        if($('.u-spTb').css('display') != 'none') {
          $info2.stop().slideToggle();
        }
      });

      $close.on('click', function(event) {
        if($('.u-spTb').css('display') != 'none') {
          $info2.stop().slideUp();
        }
      });
    });
  }
});

// $(function(){
//   const $line = $('.p-ttl__line');

//   if($line[0]) {
//     $(window).on('scroll', function(event) {
//       run();
//     });

//     run();

//     function run() {
//       let r = 0;

//       r = Math.floor($(window).scrollTop() * 300 / 360);

//       $line.css('background', 'linear-gradient(' + r + 'deg, #6ac21f, #00ae92)');
//     }
//   }
// });

// $(function(){
//   const $root = $('.home-services__item');

//   if($root[0]) {
//     $root.each(function(index, el) {
//       const $item = $(this);
//       const $fig = $item.find('.home-services__itemFigC');
//       let deg = 0;
//       let isStart = false;
//       let timer;
//       let color;

//       $(window).on('scroll', function(event) {
//         check();
//       });

//       timer = setInterval(check, 10);

//       function check() {
//         if(!isStart && $item.hasClass('is-fade')) {
//           isStart = true;

//           if($item.hasClass('-n1')) color = '#6ac21f';
//           if($item.hasClass('-n2')) color = '#66b4be';
//           if($item.hasClass('-n3')) color = '#d29618';

//           clearInterval(timer);
//           timer = setInterval(run, 10);
//         }
//       }

//       function run() {
//         deg += 5;

//         if(deg >= 360) {
//           deg = 360;
//           clearInterval(timer);
//         }

//         $fig.css('background-image', 'conic-gradient(' + color + ' ' + deg + 'deg, #fff ' + deg + 'deg)');
//         $fig.css('background-image', 'conic-gradient(' + color + ' ' + deg + 'deg, #fff ' + deg + 'deg)');
//         $fig.css('background-image', 'conic-gradient(' + color + ' ' + deg + 'deg, #fff ' + deg + 'deg)');
//       }
//     });
//   }
// });

//fade
$(function(){
  var fade = $('.fade, .fadeAni');

  fade.each(function(index, el) {
    var t = $(this);

    setTimeout(function(){
      $(window).on('resize scroll', function(event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if(h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if(sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if(d) {
        pointD = d;
      }

      if(pointH < pointSc) {
        setTimeout(function(){
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if(nextStr) {
        var nextArr = nextStr.split(' ');
        if(nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if(nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 0;
              if(nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 0;
              if(nextDelay) {
                step = delay;
              }
              if(nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function(index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function(){
                  t2.addClass('is-fade-next');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

//home fixed
$(function(){
  if($('.home-fixed__play').length) {
    const fixed_play = $('.home-fixed__play');
    const fixed_sound = $('.home-fixed__sound');
    const services_offset = $('.home-services').offset().top - $(window).innerHeight();

    if(fixed_play) {
      $(window).on('resize scroll', function(event) {
        if($(window).scrollTop() > services_offset) {
          fixed_play.addClass('is-hide');
          fixed_sound.addClass('is-hide');
        } else {
          fixed_play.removeClass('is-hide');
          fixed_sound.removeClass('is-hide');
        }
      });
    }
  }
});

const top_movie = $('.home-kv__movie video');
const sound_btn = $('.js-sound');
if(sound_btn) {
  sound_btn.on('click', function(event) {
    if(sound_btn.hasClass('is-on')) {
      top_movie.get(0).muted = true;
      sound_btn.removeClass('is-on');
    } else {
      top_movie.get(0).muted = false;
      sound_btn.addClass('is-on');
    }
  });
}

var youtubeTag = document.createElement('script');
youtubeTag.src = "https://www.youtube.com/iframe_api";
var youtubeFirstScriptTag = document.getElementsByTagName('script')[0];
youtubeFirstScriptTag.parentNode.insertBefore(youtubeTag, youtubeFirstScriptTag);
var youtubePlayers = [];

function onYouTubeIframeAPIReady() {
  $('.moviePlayerAuto').each(function(index, el) {
    var t = $(this);
    t.attr('data-player-id', youtubePlayers.length);

    var player = new YT.Player(t[0], {
      height: '360',
      width: '640',
      videoId: t.attr('data-video-id'),
      playerVars: {
      'modestbranding': 1,
      'autohide': 1,
      'controls': 0,
      'showinfo': 0,
      'rel': 0,
      'autoplay': 0,
      'playsinline': 1,
      'loop': 1,
      'playlist': t.attr('data-video-id')
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
    youtubePlayers.push(player);

    function onPlayerStateChange(event) {
      var ytStatus = event.target.getPlayerState();

      // 再生終了したとき
      if (ytStatus == YT.PlayerState.ENDED) {
        event.target.seekTo(0,true);//動画の初めにシーク
        event.target.mute();
        event.target.playVideo();
      }
    }

    // 4. The API will call this function when the video player is ready.
    function onPlayerReady(event) {
      event.target.mute();
      //event.target.playVideo();
    }

    function playVideo() {
      player.mute();
      player.playVideo();
    }

    function stopVideo() {
      player.stopVideo();
    }
  });

  setTimeout(function(){
    $('.js-youtubePlayerModal').each(function(index, el) {
      var t = $(this);
      t.attr('data-player-id', youtubePlayers.length);

      var player = new YT.Player(t[0], {
        height: '360',
        width: '640',
        videoId: t.attr('data-video-id'),
        playerVars: {
        'modestbranding': 1,
        'autohide': 1,
        'controls': 1,
        'showinfo': 0,
        'rel': 0,
        'autoplay': 0,
        'playsinline': 1
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      });
      youtubePlayers.push(player);

      function onPlayerStateChange(event) {
        /*var ytStatus = event.target.getPlayerState();

        // 再生終了したとき
        if (ytStatus == YT.PlayerState.ENDED) {
          player.mute();
          player.playVideo();
        }*/
      }

      // 4. The API will call this function when the video player is ready.
      function onPlayerReady(event) {
        //event.target.mute();
        //event.target.playVideo();
      }

      function playVideo() {
        player.mute();
        player.playVideo();
      }

      function stopVideo() {
        player.stopVideo();
      }
    });

    $('.home-remodalMovie').each(function(index, el) {
      var t = $(this);

      t.on('opening', function () {
      });

      t.on('opened', function () {
        var p = youtubePlayers[t.find('.js-youtubePlayerModal').attr('data-player-id')];
        p.playVideo();
        top_movie.get(0).pause();
      });

      t.on('closing', function (e) {
        var p = youtubePlayers[t.find('.js-youtubePlayerModal').attr('data-player-id')];
        p.stopVideo();
      });

      t.on('closed', function (e) {
        var p = youtubePlayers[t.find('.js-youtubePlayerModal').attr('data-player-id')];
        p.stopVideo();
        top_movie.get(0).play();
      });
    });
  }, 100);
}

//tab
$(function() {
  'use strict';
  const $trigger = $('.js-tab-trigger');
  const $triggerScope = $('.js-tab-trigger-scope');
  const $target = $('.js-tab-target');
  const $targetScope = $('.js-tab-target-scope');
  const currentClass = 'is-current';

  $trigger.on('click', function() {
    const $this = $(this);
    const tagId = $this.data('id');
    const $thisTarget = $('#' + tagId);
    const $thisTriggerScope = $this.closest($triggerScope);
    const $thisTargetScope = $thisTarget.closest($targetScope);

    $thisTriggerScope.find($trigger).removeClass(currentClass);
    $thisTargetScope.find($target).removeClass(currentClass);
    $this.addClass(currentClass);
    $thisTarget.addClass(currentClass);
  });
});

//Tabキー押下イベント取得
$(function() {
  $(document).on('keydown', function(event) {
      if (event.key === 'Tab') {
          // VoiceOverやスクリーンリーダー利用者を推測
          gtag('event', 'tab_keypress_detected', {
              event_category: 'Accessibility',
              event_label: 'tab keyPress Detected',
          });
      }
  });
});

//バナークリック数計測
$(function() {
  $('.track-banner').on('click', function(e) {
    const bannerId = $(this).data('banner-id');

    // GA4イベント送信
    gtag('event', 'banner_click', {
      event_category: 'Accessibility',
      event_label: bannerId
    });
  });
});
